module.exports = __webpack_public_path__ + "static/media/SA logo.d0b4fd42.png";